import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { Package, ShoppingBag, LogOut, Newspaper, Wrench, RefreshCw, BarChart2, BookmarkCheck, Ticket, BadgePercent, FileText, DatabaseBackup, ImageOff } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = async () => {
    await logout();
    nav("/admin/login");
  };

  return (
    <div className="min-h-screen bg-navy-900">
      <div className="grid lg:grid-cols-[260px_1fr] min-h-screen">
        <aside className="bg-navy-800 border-r border-gold/20 p-6 flex flex-col">
          <Link to="/" className="flex items-center gap-2 mb-8">
            <img src="/logo.png" alt="GamesTrade" className="h-9 w-auto" />
            <div>
              <div className="font-black text-sm leading-none">GAMES<span className="text-gold">TRADE</span></div>
              <div className="text-[9px] uppercase tracking-[0.25em] text-gold/80 mt-1">Admin CMS</div>
            </div>
          </Link>
          <nav className="space-y-1 flex-1">
            <SideLink to="/admin" end icon={BarChart2} label="Summary" />
            <SideLink to="/admin/products" icon={Package} label="Products" />
            <SideLink to="/admin/orders" icon={ShoppingBag} label="Orders" />
            <SideLink to="/admin/preorders" icon={BookmarkCheck} label="Pre Orders" />
            <SideLink to="/admin/repairs" icon={Wrench} label="Repairs" />
            <SideLink to="/admin/tradein" icon={RefreshCw} label="Trade In" />
            <SideLink to="/admin/coupons" icon={Ticket} label="Coupons" />
            <SideLink to="/admin/sales" icon={BadgePercent} label="Sales" />
            <SideLink to="/admin/posts" icon={Newspaper} label="Posts" />
            <SideLink to="/admin/billing" icon={FileText} label="Billing" />
            <SideLink to="/admin/backup" icon={DatabaseBackup} label="Backup" />
            <SideLink to="/admin/missing-images" icon={ImageOff} label="Missing Images" />
          </nav>
          <div className="border-t border-gold/10 pt-4 mt-4">
            {user && (
              <div className="flex items-center gap-3 mb-3">
                {user.picture && <img src={user.picture} alt="" className="w-8 h-8 rounded-full" />}
                <div className="min-w-0">
                  <div className="text-xs font-bold truncate">{user.name}</div>
                  <div className="text-[10px] text-slate-400 truncate">{user.email}</div>
                </div>
              </div>
            )}
            <button onClick={onLogout} data-testid="admin-logout" className="flex items-center gap-2 text-xs uppercase tracking-wider text-slate-400 hover:text-gold">
              <LogOut className="w-4 h-4" /> Sign out
            </button>
          </div>
        </aside>
        <main className="p-8 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

function SideLink({ to, end, icon: Icon, label }) {
  return (
    <NavLink
      to={to}
      end={end}
      data-testid={`admin-nav-${label.toLowerCase()}`}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 rounded-md text-sm font-bold uppercase tracking-wider transition ${
          isActive ? "bg-gold text-navy-900" : "text-slate-300 hover:bg-navy-700"
        }`
      }
    >
      <Icon className="w-4 h-4" /> {label}
    </NavLink>
  );
}
